import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { useTimestamp } from "@/hooks";
import { TooltipItem } from "@/sx-layout/components/plotmap/components/TooltipItem";
import { Mark, MarkType } from "@/sx-layout/models";

type Props = {
  data: Mark;
  leftOrRight: "left-aligned" | "right-aligned";
};

export const TooltipMark: FC<Props> = ({ data, leftOrRight }) => {
  const { t } = useTranslation();

  const { formattedInsertDatetime, insertUserNameWithCompanyName } = useTimestamp(data.timestamp);

  return (
    <div
      style={leftOrRight === "left-aligned" ? { left: "15px" } : { right: "15px" }}
      className={`
        sx-layout-tooltip
        border-4
        border-[#dea321]
        border-solid
        text-[13px]
        shadow-[0_4px_4px_0px_rgba(0,0,0,0.3)]
        rounded-lg
        p-3
        bg-[#fff]
        z-10
      `}
      id="tooltip-mark"
    >
      <TooltipItem
        title={t("mark")}
        value={t(Object.values(MarkType).find((type) => type.id === data.mark_type_id)?.i18n)}
      />
      <TooltipItem title={t("size")} value={`${Math.round(data.size * 100)}%`} />
      <TooltipItem title={t("operation_time")} value={`${data.use_start_hour}~${data.use_end_hour}`} />
      <TooltipItem title={t("content")} value={data.work_content} />
      <TooltipItem title={t("belonging")} value={data.company_name} />
      <TooltipItem title={t("assignee")} value={data.charge_user_name} />
      <TooltipItem title={t("contact")} value={data.phone_number} />
      <TooltipItem title={t("note")} value={data.note} />
      <br />
      <TooltipItem metaData={true} title={t("created_at")} value={formattedInsertDatetime} />
      <TooltipItem metaData={true} title={t("registered_person")} value={insertUserNameWithCompanyName} />
    </div>
  );
};
